import React from 'react';

import Table, { TableHeader, TableRow } from '~components/common/Table';

import ScrollableAnchor from 'react-scrollable-anchor';
import slugify from 'slugify';
import { tableLayoutProps } from './propTypes';

import rowRenderers from './RowRenderers';

function TableLayout({
  frontmatter,
  infoSlug,
  stateInfos,
  infoFields,
  overrides,
  title,
}) {
  return (
    <div>
      {title && (
        <ScrollableAnchor id={slugify(title.toLowerCase())}>
          <h2>{title}</h2>
        </ScrollableAnchor>
      )}
      <Table>
        <thead className='hidden md:table-header-group'>
          <TableRow>
            <TableHeader>State</TableHeader>
            {frontmatter.headers
              ? frontmatter.headers.map((header) => (
                  <TableHeader key={header}>{header}</TableHeader>
                ))
              : infoSlug.map((slug, i) => {
                  if (
                    frontmatter.infoSlugHeaders &&
                    frontmatter.infoSlugHeaders[i]
                  ) {
                    return (
                      <TableHeader id={slug} key={slug}>
                        {frontmatter.infoSlugHeaders[i]}
                      </TableHeader>
                    );
                  }
                  const field = infoFields.find((f) => f.slug === slug);
                  if (!field) {
                    // eslint-disable-next-line jsx-a11y/control-has-associated-label
                    return <TableHeader />;
                  }
                  return (
                    <TableHeader key={field.slug}>
                      {field.description}
                    </TableHeader>
                  );
                })}
            {frontmatter.stateListAppendTextHeader && (
              <TableHeader>{frontmatter.stateListAppendTextHeader}</TableHeader>
            )}
          </TableRow>
        </thead>
        <tbody>
          {stateInfos.map((state) => {
            const Renderer = rowRenderers[frontmatter.rowRenderer ?? 'default'];

            return (
              <Renderer
                key={state.fieldValue}
                frontmatter={frontmatter}
                infoSlug={infoSlug}
                stateInfos={stateInfos}
                overrides={overrides}
                infoFields={infoFields}
                state={state}
              />
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

TableLayout.propTypes = tableLayoutProps;

export default TableLayout;
